<template>
    <v-card flat style="background-color: #e0f3fd53; border: 1px solid #e0f3fd" :class="halfScreen ? 'my-0' : 'my-3'">
        <v-card-title class="hoverEdit">
            <div class="toggle-button pl-2 d-flex align-center justify-space-between" @click="toggleCollapse">
                <div class="d-flex align-center">
                    <span style="font-size: 14px">
                        QA {{ type == "review" ? "Pending" : "Completed" }}
                    </span>
                    <!-- <v-icon v-if="type != 'review'" color="primary" class="ml-2" @click="addQaTask()">mdi-plus-circle</v-icon> -->
                    <v-tooltip activator="parent" location="bottom">Add Errors</v-tooltip>
                </div>
                <v-checkbox
                    v-if="(failBox && QAdata && QAdata.length > 0 && issueData.qc_required == 1)"
                    v-model="showFailOnly"
                    color="error"
                    label="Fail"
                    density="compact"
                    hide-details
                    class="ml-14"
                ></v-checkbox>
            </div>
        </v-card-title>
        <!-- <v-divider /> -->
        <v-card-text class="my-0 pa-0 " v-if="filteredQAdata && filteredQAdata.length > 0">
            <v-row no-gutters class="my-0 py-2 px-2 align-center qaPending" dense v-for="(value, index) in filteredQAdata" :key="index">
                <v-col cols="2" class=" pl-0">
                    <CustomAvatar class=" ml-2" :userId="value.user_id" :size="'medium'" />
                </v-col>

                <v-col cols="7" class="pt-1  pr-0" v-if="type != 'review'">
                    <!-- <div class="name-condition" style="position: relative; bottom: 8px"> -->
                        <div>
                            <span class="cardTitle">
                                {{ value.qa_first_name }} {{ value.qa_last_name }}
                                <br />
                                <small>
                                    {{ value.reference_num}}
                                </small>
                                <br />
                                <span class="orange--text">
                                    <small>{{
                                        moment(value.created).format("MM/DD/YYYY HH:mm")
                                    }}</small>
                                </span>
                            </span>
                        </div>
                    <!-- </div> -->
                    <!-- <br /> -->
                </v-col>

                <v-col cols="7" v-if="type == 'review'">
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <span class="cardTitle">
                        {{ value.user_first_name }} {{ value.user_last_name }}
                        <br />
                        <small>
                          {{ value.reference_num}}
                        </small>

                        <br />
                        <small>
                          {{ moment(value.created).format("MM/DD/YYYY HH:mm") }}
                        </small>
                      </span>
                    </div>
                
                    <v-btn
                      v-if="value.user_id != userLS.id && showEdit && exceptStage && issueDataforQA.stage == 'closed'"
                      @click="editQATask(value)"
                      variant="text"
                      class="btn-color"
                    >
                      <img
                        src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/edit.svg"
                        style="width: 16px; height: 20px"
                      />
                    </v-btn>
                  </div>
                </v-col>

                <!-- <v-col cols="2">
                 
                </v-col> -->

                <v-col class="mt-2 chippp" cols="3" v-if="type != 'review'">
                    <v-chip class="chipp" :class="getChipClass(value.pass)" label v-on="on">
                        {{
                            value.pass === "1"
                            ? "Pass"
                            : value.pass === "0"
                                ? "Fail"
                                : "Review"
                        }}
                    </v-chip>
                    <!-- (value.user_id == userLS.id) || showEdit2 -->
                    <v-btn icon color="#FDD9DB" fab size="x-small" @click="reTestQATask(value)" v-if="(value.pass === '0' && issueData.qc_required == 1)" class="btn-color retest">
                        <v-icon :class="{ 'rotating': isSyncing }"  color='red' size="medium" >mdi-sync</v-icon>
                        <v-tooltip activator="parent" location="bottom">Retest</v-tooltip>   
                    </v-btn>
                
                </v-col>
                <v-col class="text-right chippp " cols="2"  v-if="(type == 'review' && allow) ||(type != 'review' && showEdit2)" >
                    <v-btn @click="editQATask(value)" v-if="canEditTask(value)" variant="text" class="btn-color">
                        
                        <img src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/edit.svg"
                         style="width: 20px;"/>
                        <v-tooltip activator="parent" location="bottom">Edit</v-tooltip>                     
                    </v-btn>
                
                </v-col>
                <v-col class="text-right chippp " cols="2" v-if="type != 'review'">
                    <v-btn @click="viewQATask(value)" variant="text" class="btn-color">
                        <img src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Eye.svg"
                            style="width: 20px;" />
                            <v-tooltip activator="parent" location="bottom">View</v-tooltip>
                            <hr data-v-f8c0a236="" class="v-divider v-theme--myCustomLightTheme" aria-orientation="horizontal" role="separator" style="background-color: rgb(173, 173, 173);">
                    </v-btn>                 
                </v-col>
                <!-- <v-col class="text-right chippp " cols="2" v-if="type != 'review' && showDelete">
                    <v-btn @click="deleteRecord(value)" variant="text" class="btn-color">
                        <img src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/delete.svg"
                            style="width: 20px;" />
                            <v-tooltip activator="parent" location="bottom">Delete</v-tooltip>
                    </v-btn>                 
                </v-col> -->
            

                <!-- <v-divider class="divider" v-if="QAdata.length > 1"></v-divider> -->
            </v-row>
        </v-card-text>

        <v-card-text v-else class="pa-0">
            <v-container class="text-center pt-0" justify-center>
                <v-icon style="font-size:100px;" class="">
                    <img :src="require('@/assets/no-data-found.svg')" width="56" height="56" />
                </v-icon>
                <br />
                <span class="text-body2 mt-2">
                    No QA task found for selected task
                </span>
            </v-container>
        </v-card-text>
    </v-card>
    <v-dialog v-model="showQcDialog" :width="1100" persistent>
        <QcTask :stage='stage' :issueData="viewType === 'add' ? { pass: '0'} : errorLogs" @close="closeQC" :viewType="viewType" @updateData="updateData"/>
    </v-dialog>

    <v-dialog v-model="showQaDialog" :width="1100" persistent>
        <QaTask ref="QaTask" @closeDialog="closeQATask()" @reload="getQAdata()" :timeSheetDefaults="getTimeSheetDefaults()"
            :viewType="viewType" :issueId="issueId" :issueData="issueData" @updateData="updateData" :id="QAId"></QaTask>
    </v-dialog>
    <v-dialog v-model="conformationDialog" :width="openTextfield ? 520 : 420" persistent>
        <v-card class="rounded-xl elevation-8">
            <v-card-title class="pa-6 pb-4">
                <div class="d-flex align-center justify-center text-center">
                    <!-- <v-icon 
                        :color="openTextfield ? 'primary' : 'warning'" 
                        size="28" 
                        class="mr-3"
                    >
                        {{ openTextfield ? 'mdi-text-box-outline' : 'mdi-help-circle-outline' }}
                    </v-icon> -->
                    <div>
                        <h3 class="text-h6 font-weight-medium mb-1">
                            {{ !openTextfield ? 'Confirm Retest' : 'Retest Reason' }}
                        </h3>
                        <p class="text-body-2 text-medium-emphasis mb-0">
                            {{ !openTextfield ? 'Are you sure you want to retest this QA task?' : 'Please provide a reason for retesting' }}
                        </p>
                    </div>
                </div>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-6" v-if="openTextfield">
                <div class="d-flex justify-space-between align-center">
                    <v-label class="text-h6">Reason for retest:</v-label>
                    <v-checkbox
                        v-model="qcError"
                        label="QC Error"
                        color="primary"
                        density="compact"
                        style="bottom: 0;"
                    ></v-checkbox>
                </div>
                <v-textarea
                    v-model="retestReason"
                    label="Reason for retest"
                    placeholder="Enter the reason for retesting..."
                    rows="3"
                    variant="outlined"
                    color="primary"
                    required
                    class="mb-2"
                ></v-textarea>
                <!-- <div class="text-caption text-medium-emphasis">
                    <v-icon size="16" class="mr-1">mdi-information-outline</v-icon>
                    This reason will be recorded for audit purposes
                </div> -->
            </v-card-text>

            <v-card-actions class="pa-6 pt-2">
                <v-btn 
                    color="#f2f2f0" 
                    variant="elevated"
                    @click="closeDialog"
                    class="mr-3"
                >
                    Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn 
                    v-if="!openTextfield" 
                    color="primary" 
                    variant="elevated"
                    @click="openTextfield = true"
                >
                    Continue
                </v-btn>
                <v-btn 
                    v-if="openTextfield" 
                    :loading="loader"
                    color="primary" 
                    variant="elevated"
                    @click="reTestQATask()"
                    :disabled="!retestReason || retestReason.trim().length < 4"
                >
                    <v-icon start>mdi-sync</v-icon>
                    Retest
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
  
<script>
import CustomAvatar from "@/components/ui/CustomAvatar.vue";
import moment from "moment-timezone";
import QaTask from "../issues/views/QaTask.vue";
import SubCategoryService from '@/api/service/SubCategory/SubCategoryService'
import QaService from "@/api/service/Qa/QaService";
import RoleService from "@/api/service/Role/RoleService";
import IssueService from "@/api/service/Issue/IssueService";
import QcTask from "./QcTask.vue";
import ForumService from "@/api/service/Forum/ForumService";
import ErrorLogsService from "@/api/service/ErrorLogs/ErrorLogsService";
// import ErrorLogsService from "@/api/service/ErrorLogs/ErrorLogsService";
export default {
    props: ["issueId", "refresh", "issueData", "type", "halfScreen", "showEdit", "exceptStage", "allow","failBox"],
    components: {
        CustomAvatar,
        QaTask,
        QcTask,
    },
    data() {
        return {
            userLS: [],
            QAdata: [],
            aboveTL: false,
            issueDataforQA: [],
            errorLogs:{},
            QAId: '',
            isCollapsed: false,
            showQcDialog:false,
            showQaDialog: false,
            editData: {},
            viewType: null,
            showDelete:false,
            showEdit2:false,
            stage:null,
            idForQa:null,
            isSyncing:false,
            subCategoryData:{},
            showFailOnly: false,
            conformationDialog: false,
            openTextfield: false,
            retestValue: null,
            retestReason: '',
            qcError: false,
            loader: false,
            qaTaskId: null
        };
    },
    updated() {
        this.getQAdata();
    },

    created() {
        console.log(this.exceptStage,"exceptStage!!!!")
        this.getUserIdFromLS();
        if( this.type != "review"){
            this.getAccessToDelete()
            this.getAccessToEdit()
            this.getQAdata()
        }
        if(this.issueData && this.issueData.length > 0){
            this.getSubCategory()
        }
        this.getQAdata()
    },
    watch: {
        getQataskStatus() {
            if (this.getQataskStatus) {
                this.getQAdata();
            } else {
                this.getQAdata();
            }
        },

        getReload() {
            if (this.getReload) {
                this.getQAdata();
            }
        },

        refresh() {
            this.getQAdata();
            this.$emit("setRefreshFalse");
        },
    },
    computed: {
        getReload() {
            return this.$store.getters.getAssignee;
        },        
        getQataskStatus() {
            return this.$store.getters.getQaUpdate;
        },
        filteredQAdata() {
            if (this.showFailOnly) {
                return this.QAdata.filter(item => item.retest === 1);
            }
            console.log(this.QAdata,"qaretestdata")
            return this.QAdata;
        },
    },


    methods: {
        moment,
        updateData(data,type){
            if(!type){
              data.fromQAtask = true
              this.$emit('updateData',data)  
            }
            else{
                this.$emit('updateData',data,type)
            }
        },
        closeDialog(){
            this.conformationDialog = false;
            this.openTextfield = false;
            this.retestReason = '';
            this.qcError = false;
            this.isSyncing = false;
        },
        async deleteRecord(value){
            let obj ={
                id:value.id,
                active:0,
                deleted:1
            }
            await QaService.update(obj)
            this.getQAdata()
        },       

        async getAccessToDelete(){
            let res = await RoleService.getAccessForRule({access_role:'TL',condition:'above',user_role:this.userLS.roles.code})
            this.showDelete = res && res ==true?true:false
        },

        async getErrorLogsData(value){
            let res = await IssueService.getIssueById({issue_id: value})
            this.errorLogs = res 
            console.log(this.errorLogs,"getErrorLogsData")
        },
                 
        async getAccessToEdit(){
            let res = await RoleService.getAccessForRule({access_role:'PL',condition:'above',user_role:this.userLS.roles.code})
            this.showEdit2 = res && res ==true?true:false
        },
        canEditTask(value) {
            const hasEditAccess = (value.user_id == this.userLS.id) || this.showEdit2;
            if(this.issueData.qc_required == 1){
                if (!this.showFailOnly) {
                    return hasEditAccess;
                }
                return this.userLS.roles.role_type <= 5 && hasEditAccess;
            } else {
                return hasEditAccess;
            }
        },
        qaClicked() {
            this.$emit("qaClicked");
            
        },
        addQaTask(){
            // if(this.issueData.work_space_name == 'qc testing'){
                this.viewType = "add";
                this.stage = "qcfail";
                this.showQcDialog = true;
            // } else {
            //     let status = this.$store.getters.getQaAdd;
            //     this.$store.commit("ADD_QA_TASK", !status);  
                // this.viewType = "add";
                // this.showQaDialog = true;
            // }
        },
        getTimeSheetDefaults() {
            if (this.issueData.id && !this.id) {
                return {
                    issueId: this.issueData.id,
                    refNum: this.issueData.ref_num,
                    name: this.issueData.name,
                    startDate: this.issueData.start_date,
                    accountId: this.issueData.account_id,
                    accountName:
                        this.issueData.accounts && this.issueData.accounts.name
                            ? this.issueData.accounts.name
                            : "",
                    projectId: this.issueData.project_id,
                    projectName:
                        this.issueData.projects && this.issueData.projects.name
                            ? this.issueData.projects.name
                            : "",
                    taskName:
                        this.issueData.tasks && this.issueData.tasks.name
                            ? this.issueData.tasks.name
                            : "",
                    taskId: this.issueData.task_id,
                    user_id: this.editData.user_id,
                    id: this.editData.id,
                    pass: this.editData.pass,
                    severity: this.editData.severity,
                    cause: this.editData.cause,
                    impact: this.editData.impact,
                    description: this.editData.description,
                    qa_user_id: this.editData.qa_user_id,
                };
            }
        },
        async editQATask($value) {
            if($value.child_issue_id){
                console.log($value,"$value@@")
                this.stage = $value.pass == 1 ? 'qcpass' : 'qcfail'
                this.editData = $value;
                this.QAId = this.editData.id
                this.viewType = "edit"
                await this.getErrorLogsData($value.child_issue_id)
                this.showQcDialog = true;
            } else {
                this.showQaDialog = true;
                this.editData = $value;
                this.QAId = this.editData.id
                this.viewType = false
            }
        },
        async viewQATask($value) {
            if($value.child_issue_id){
                console.log("viewif")
                this.stage = this.showFailOnly ? 'qcfail' : ($value.pass == 1 ? 'qcpass' : 'qcfail')
                this.editData = $value;
                this.QAId = this.editData.id
                this.viewType = "view";
                await this.getErrorLogsData($value.child_issue_id)
                this.showQcDialog = true;
            } else {
                console.log("viewelse")
                this.showQaDialog = true;
                this.editData = $value;
                this.QAId = this.editData.id
                this.viewType = true;
            }
        },
        async reTestQATask(value){
            //--------------------------------------------
            console.log(value,"reTestQATask")
            //-------------------------------------------
            if(!value){
                let forumsContainer = []
                this.loader = true
                console.log(this.retestValue,"this.retestValue",this.retestReason,"this.retestValue",this.qcError)
                await this.getSubCategory()
                this.qaTaskId = this.retestValue.child_issue_id
                let res = await IssueService.getIssueById({issue_id: this.retestValue.child_issue_id})
                console.log(res,"this.retestValue")
                let data={
                    issueData : res,
                    sub_category_code: this.subCategoryData.code ? this.subCategoryData.code : '',
                    qc_required: this.issueData.qc_required ? this.issueData.qc_required : 0,
                    email: this.userLS.email
                }
                this.$store.commit("QATASK_CHANGE", !this.$store.getters.getQaUpdate);
                let forumData = {
                    key_type: "issue",
                    key_id: this.retestValue.child_issue_id,
                    action: "QC-Retest",
                    description:  `${this.userLS.username} ask retest, reason for "${this.qcError?"QC ERROR-":""}${this.retestReason}"`,
                };
                let $response = await ForumService.create(forumData);
                console.log($response.data,"forumforum--");
                this.$emit("refreshSubtask",forumData)
                this.loader = false
                this.isSyncing = false;
                this.conformationDialog = false;
                this.retestValue = null;
                this.retestReason = '';
                this.qcError = false;
                let oldElData = await ErrorLogsService.findAll({qa_issue_id: this.qaTaskId})
                console.log(oldElData,"oldErrorlog");
                if(Array.isArray(JSON.parse(oldElData[0].qc_reason))){
                    forumsContainer = JSON.parse(oldElData[0].qc_reason)
                    console.log(forumsContainer,"oldErrorlog111");
                    forumsContainer.push($response.data.data[0].id)
                }
                else{
                    if(typeof oldElData[0].qc_reason == 'string'){
                        forumsContainer.push(JSON.parse(oldElData[0].qc_reason))
                    } 
                    else if (oldElData[0].qc_reason == null ) {
                        forumsContainer = []
                    } 
                    else{
                        forumsContainer.push(oldElData[0].qc_reason)
                    }               
                    forumsContainer.push($response.data.data[0].id)
                }
                let updData = {
                    id:res.id,
                    qc_reason: JSON.stringify(forumsContainer)
                }
                let errorlogResponse = await ErrorLogsService.qcReason(updData)
               

                console.log(errorlogResponse,"errrUUUUU")
                await IssueService.retestSubTask(data)
                this.getQAdata()
                this.$emit("refreshSubtask")
            }
            else{
                this.isSyncing = true;
                this.conformationDialog = true;
                this.retestValue = value
            }
        },

        async getSubCategory(){
            let $subCategory = await SubCategoryService.findAll({ id: this.issueData.sub_category_id })
            if ($subCategory && $subCategory.length > 0 && $subCategory[0].qa_required == 1) {
                // alert('sub')
                this.subCategoryData = $subCategory[0]
                // console.log(this.subCategoryData,"this.subCategoryData%%%")
                // this.qcDialog = true;
            }
        },

        closeQATask() {
            this.showQaDialog = false;
            this.editData = {};
        },
        closeQC(data){
			this.showQcDialog = false
            this.$emit('close',data)
		},
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        async getUserIdFromLS() {
            this.userLS = JSON.parse(localStorage.getItem("user_details"));
        },

        async getQAdata() {
            if (this.issueId) {
                if (this.type == "review") {
                    let res = await QaService.getQaForIssue({ issueId: this.issueId });
                    this.QAdata = res;
                    console.log(this.QAdata,"insqa");
                    if(this.QAdata && this.QAdata.length > 0 && this.QAdata[0].child_issue_id){
                        this.issueDataforQA = await IssueService.getIssueById({issue_id: this.QAdata[0].child_issue_id});
                    }
                } else {
                    let res = await QaService.getQaForIssue({
                        issueId: this.issueId,
                        pass: [0, 1],
                    });
                    this.QAdata = res;
                    // console.log(this.QAdata,"filteed0");
                    for(let i of this.QAdata){
                        let issueRes = await IssueService.getIssueById({issue_id: i.child_issue_id});
                        console.log(issueRes,"filteed");
                        if(issueRes.qa_task_retest == 1 || issueRes.qa_task_retest == '1'){
                            i.retest = 1
                        }
                        else{
                            i.retest = 0
                        }
                    }
                    console.log(this.QAdata,"filteed1");
                }
                //  } else {
                //     let res = await ErrorLogsService.getErrorForIssue({
                //         issueId: this.issueId,
                //         pass: [0, 1],
                //     });
                //     this.QAdata = res;
                // }
            }
        },

        getAvatarName(value) {
            if (this.type != "review") {
                let fName =
                    value && value.qa_user.qa_first_name
                        ? value.qa_user.qa_first_name.charAt(0)
                        : "";
                let lName =
                    value && value.qa_user.qa_last_name
                        ? value.qa_user.qa_last_name.charAt(0)
                        : "";
                let name = fName + lName;
                return name;
            } else {
                let fName =
                    value && value.users.user_first_name
                        ? value.users.user_first_name.charAt(0)
                        : "";
                let lName =
                    value && value.users.user_last_name
                        ? value.users.user_last_name.charAt(0)
                        : "";
                let name = fName + lName;
                return name;
            }
        },

        getChipClass(pass) {
            if (pass === "1") {
                return "green-chip";
            } else if (pass === "0") {
                return "red-chip";
            } else if (pass === null) {
                return "yellowgreen-chip";
            } else {
                return "";
            }
        },
    },
};
</script>
  
<style scoped>
.qaPending{
    border-bottom: 1px solid #bcbcbc;
}
/* .retest{
    background-color: #fff;
    /* padding: 0px 20px !important; 
    color: red;
    font-size: 10px !important;
    font-weight: 600 !important;
} */
.toggle-button {
    cursor: pointer;
}

.toggle-button span {
    margin-right: 8px;
}

.toggle-button v-icon {
    transition: transform 0.3s;
}

.toggle-button:hover v-icon {
    transform: rotate(180deg);
}

.divider {
    border-top: 1px dotted #000000;
    opacity: 0.5;
}

.grey-bg {
    background-color: #f4f4f423;
}

/* .outlined {
    border: 1px solid #dfdfdf;
  } */

>>>.v-chip.v-chip--size-default {
    --v-chip-size: 0.875rem;
    --v-chip-height: 19px;
    font-size: 10px;
    padding: 0 9px;
}

.cardTitle {
    color: #000;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
}

.bold-medium {
    font-weight: 600;
}

.onText {
    color: #636363;
    font-weight: 500;
    text-align: start;
    opacity: 1 !important;
}

.onText1 {
    font-size: 10px;
    padding: 0 !important;
    margin: 0 !important;
}

.green-chip {
    background-color: #9af5d5;
    color: #000000;
}

.ifNoQa {
    text-align: center;
}

.red-chip {
    background-color: #fcc4c4;
    color: #000000;
}

.yellowgreen-chip {
    background-color: #9ae0f5;
    color: #000000;
}

.name-condition {
    display: grid;
}

.hoverEdit {
    font-size: 14px;
}

.chippp {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.chipp {
    widows: 40px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.rotating {
  animation: spin 1s linear infinite;
}
</style>